/**
 * Created by Ning Jiang on 2022-05-30.
 */
import {WinPresentationController} from "../WinPresentationController";
import {Serial} from "../../Serial";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {SerialGameMode} from "../../server/SerialGameMode";
import {gsap} from "gsap";
import {XSplitSymbol} from "../../symbol/XSplitSymbol";

export class FreespinUpdateController extends WinPresentationController {

    constructor() {
        super("FreespinUpdateController", false);
    }

    protected hasWin():boolean {
        const data = Serial.model.parsedGameData;
        return data.mode.includes(GameMode.FREESPIN) && !data.mode.includes("SUPER") && data.nextMode === SerialGameMode.FREESPIN_SUPER;
    }

    protected async createWinAnimation():Promise<any> {
        const symId = Serial.model.parsedGameData.scatterPositions[4];
        if(symId > -1) {
            const sym = <XSplitSymbol>Serial.getSymbol(4, symId);
            await Promise.resolve(sym.playWinAttention());
        }

        await new Promise<void>(resolve => {
            Serial.freespinIntro.show(() => {
                Serial.keypadPlugin.setZeroBetSpinCounter(Serial.model.parsedGameData.freespinsLeft);
                resolve();
            });
        });
    }
}